function setLazyImages () {
    var lazyImages = [].slice.call(
        document.querySelectorAll(".lazy > source")
    )
    if (lazyImages.length > 0) {
        if ("IntersectionObserver" in window) {
            let lazyImageObserver =
            new IntersectionObserver(function(entries, observer) {
                entries.forEach(function(entry) {
                    if (entry.isIntersecting) {
                        let lazyImage = entry.target;
                        lazyImage.srcset = lazyImage.dataset.srcset;
                        lazyImage.nextElementSibling.srcset = lazyImage.dataset.srcset;
                        lazyImage.parentElement.classList.remove("lazy");
                        lazyImageObserver.unobserve(lazyImage);

                        // Now load the next <picture> sources sibling which was not intersecting b/c it was not visible
                        let $lazyHoverImageSrcs = $(lazyImage).parent('picture').next("picture").find("source");
                        if ($lazyHoverImageSrcs) {
                            $lazyHoverImageSrcs.each(function() {
                                this.srcset = this.dataset.srcset;
                            });
                        }
                    }
                });
            });

            lazyImages.forEach(function(lazyImage) {
                lazyImageObserver.observe(lazyImage);
            });
        } else {
            // Not supported, load all images immediately
            lazyImages.forEach(function(image) {
                image.nextElementSibling.src = image.nextElementSibling.dataset.srcset;
            });
        }
    }
}

document.addEventListener("DOMContentLoaded", function(event) {
    setLazyImages();
});


const observer = new MutationObserver((mutations) => {
  mutations.forEach((mutation) => {
      if (mutation.type === "childList" && mutation.addedNodes.length > 0) {
        setLazyImages()
    }
  });
});
observer.observe(document.body, {childList: true, subtree: true});
